import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CartButtonModule } from './cartButton';
import { CartEmptyBlockModule } from './cartEmptyBlock';
import { CartFooterModule } from './cartFooter';
import { CartHeaderModule } from './cartHeader';
import { CartItemsModule } from './cartItems';
import { CartLocationButtonModule } from './cartLocationButton';
import { CartViewModule } from './cartView';

const toExport: any[] = [
    CartButtonModule,
    CartEmptyBlockModule,
    CartFooterModule,
    CartHeaderModule,
    CartItemsModule,
    CartLocationButtonModule,
    CartViewModule,
];

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        ...toExport
    ],
    providers: [],
})
export class CartComponentsModule { }
